import de from './de.json'
import en from './en.json'

export type tLocales = 'en' | 'de'
const messages: Record<string, Record<string, string>> = { de, en }
const defaultLang = 'de'
const availableLang: tLocales[] = ['de', 'en']

export { messages, defaultLang, availableLang }
